import React from "react";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import AppWrapper from "./components/AppWrapper";
import { AuthProvider } from "./contexts/AuthContext";
import { ConsoleAuthProvider } from "./contexts/ConsoleAuthContext";

function App() {
  return (
    <AuthProvider>
      <ConsoleAuthProvider>
        <AppWrapper />
        <Analytics />
      </ConsoleAuthProvider>
    </AuthProvider>
  );
}

export default App;